import { render, staticRenderFns } from "./navigation-menu-footer.component.vue?vue&type=template&id=59c87848&scoped=true"
import script from "./navigation-menu-footer.component.vue?vue&type=script&lang=ts"
export * from "./navigation-menu-footer.component.vue?vue&type=script&lang=ts"
import style0 from "./navigation-menu-footer.component.vue?vue&type=style&index=0&id=59c87848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c87848",
  null
  
)

export default component.exports